import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { QuizTabStatus } from '@edtech-ui/constants/quiz-nav.enum';
import { StudentNavClassroom } from '@edtech-ui/core/models/nav-courses-and-quizzes/get-all-nav-student-classroom';
import { StudentNavQuiz } from '@edtech-ui/core/models/nav-courses-and-quizzes/get-all-quizzes';
import { StudentService } from '@edtech-ui/core/services/student-management/student.service';
import { TeacherServicesService } from '@edtech-ui/core/services/teacher-services.service';
import { ToastrService } from 'ngx-toastr';
import { PaginatorModule } from 'primeng/paginator';
import { catchError, debounceTime, finalize, of, Subject, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-student-all-quiz',
	standalone: true,
	imports: [CommonModule, PaginatorModule, MatProgressSpinnerModule],
	templateUrl: './student-all-quiz.component.html',
	styleUrls: ['../../../teacher/quizzes/quizzes.component.scss']
})
export class StudentAllQuizComponent implements OnInit {

	QuizTabStatus = QuizTabStatus;
	selectedTab: QuizTabStatus = QuizTabStatus.ALL;
	statusFilter: string = QuizTabStatus.ALL;
	studentQuizzes: StudentNavQuiz[] = [];
	allStudentQuizzes: StudentNavQuiz[] = [];
	classrooms: StudentNavClassroom[] = [];
	isLoading = false;
	pageNo: number = 1;
	pageSize: number = 10;
	totalPages: number = 0;
	classroomId: number = 0;
	classroomFilter: number = 0;
	totalCount: number = 0;
	Teacherfilter: string = '';
	searchCourseByName: string = '';
	subscription = new Subscription();
	searchInput$ = new Subject<string>();

	selectTab(tab: QuizTabStatus) {
		this.selectedTab = tab;
		this.pageNo = 1;

		if (tab === QuizTabStatus.ALL) {
			this.statusFilter = QuizTabStatus.ALL
		} else if (tab === QuizTabStatus.PENDING) {
			this.statusFilter = QuizTabStatus.PENDING;
		} else if (tab === QuizTabStatus.COMPLETE) {
			this.statusFilter = QuizTabStatus.COMPLETE;
		} else if (tab === QuizTabStatus.IN_PROGRESS) {
			this.statusFilter = QuizTabStatus.IN_PROGRESS;
		}
		this.getAllStudentQuiz();
	}

	constructor(private route: ActivatedRoute,
		private _teacherService: TeacherServicesService,
		private _toastr: ToastrService,
		private _studentService: StudentService,
		private router: Router,
	) { }

	ngOnInit(): void {
		this.route.queryParams.subscribe(params => {
			if (params['tab']) {
				this.selectedTab = params['tab'] as QuizTabStatus;
			}
		});
		this.getAllStudentQuiz();
		this.getAllStudentClassrooms();

		this.subscription.add(
			this.searchInput$.pipe(debounceTime(300)).subscribe(value => {
				this.searchCourseByName = value;
				this.pageNo = 1;
				this.getAllStudentQuiz();
			})
		);
	}

	getAllStudentQuiz() {
		this.isLoading = true;
		const params = {
			page: this.pageNo,
			page_size: this.pageSize,
			search: this.searchCourseByName,
			classroom_filter: this.classroomFilter,
			status_filter:this.statusFilter
		};
		this.subscription.add(
			this._teacherService.getAllStudentQuizzes(params).pipe(
				tap(response => {
					if (response.Success) {
						this.studentQuizzes = response.Data.quizzes;
						this.allStudentQuizzes = response.Data.quizzes
						this.totalPages = response.Data.total_pages;
						this.totalCount = response.Data.total_count;
					}
					else {
						this.studentQuizzes = [];
						this.allStudentQuizzes = [];
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while fetching courses');
					return of(null);
				}),
				finalize(() => {
					this.isLoading = false;
				}),
			).subscribe()
		)
	}

	clearSearch() {
		this.searchCourseByName = '';
		this.pageNo = 1;
		this.getAllStudentQuiz();
	}

	getAllStudentClassrooms() {
		this.subscription.add(
			this._studentService.getAllNavStudentClassrooms().pipe(
				tap(response => {
					if (response.Success) {
						this.classrooms = response.Data.classrooms;
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong file fetching the classrooms');
					return of(null);
				})
			).subscribe()
		)
	}

	onFilterChange() {
		this.pageNo = 1;
		this.getAllStudentQuiz();
	}

	onPageChange(event: any) {
		this.pageNo = event.page + 1;
		this.pageSize = event.rows;
		this.getAllStudentQuiz();
	}

	onSearchChange(search: string) {
		this.searchInput$.next(search);
	}

	clearClassroom() {
		this.classroomFilter = 0;
		this.pageNo = 1;
		this.getAllStudentQuiz();
	}

	getSelectedClassroomName(): string {
		const classroom = this.classrooms.find(c => c.id === +this.classroomFilter);
		return classroom ? classroom.name : '';
	}

	goToQuizPage(quiz: StudentNavQuiz) {
		const classroom = this.classrooms.find(c => c.name === quiz.classroom);
		const classroomId = classroom?.id;

		if (!classroomId) {
			this._toastr.error('Classroom ID not found!');
			return;
		}
		this.router.navigate(['student-dashboard/classroom-detail-page', classroomId, 'quiz']
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}